import GaiaIcon, {GaiaIconProps} from '@gaia/icons/GaiaIcon';
import SubscriptionTooltip, {SubscriptionTooltipProps} from '@map/SubscriptionTooltip';
import {ListItemButton, type ListItemButtonProps, ListItemIcon, ListItemText} from '@mui/material';
import clsx from 'clsx';
import {useContext} from 'react';

import classes from './Controls.module.css';
import {MapControlsExpandedContext} from './ControlsDrawer';

interface GaiaMapControlProps extends ListItemButtonProps {
    active: boolean;
    icon: GaiaIconProps['name'];
    title: string;
    label: string;
    analyticsContext?: SubscriptionTooltipProps['analyticsContext'];
    subscription?: SubscriptionTooltipProps['subscription'];
}

export function GaiaMapControl({
    disabled,
    active,
    onClick,
    title,
    label,
    icon,
    analyticsContext = 'controlsDrawer',
    subscription,
}: GaiaMapControlProps) {
    const expanded = useContext(MapControlsExpandedContext);
    return (
        <SubscriptionTooltip
            placement='right'
            title={title}
            subscription={subscription}
            enterDelay={500}
            analyticsContext={analyticsContext}
            disableFocusListener={expanded && !subscription}
            disableHoverListener={expanded && !subscription}
            disableTouchListener={expanded && !subscription}
        >
            <li>
                <ListItemButton
                    selected={active}
                    disableGutters
                    aria-label={title}
                    className={clsx(
                        classes.mapControl,
                        classes.controlsDrawerButton,
                        active && classes.active
                    )}
                    disabled={disabled}
                    onClick={onClick}
                >
                    <ListItemIcon className={classes.mapControlIcon}>
                        <GaiaIcon name={icon} />
                    </ListItemIcon>
                    <ListItemText primary={label} />
                </ListItemButton>
            </li>
        </SubscriptionTooltip>
    );
}
